import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=be64214e&scoped=true&"
import script from "./ImageGallery.vue?vue&type=script&lang=js&"
export * from "./ImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=be64214e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be64214e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be64214e')) {
      api.createRecord('be64214e', component.options)
    } else {
      api.reload('be64214e', component.options)
    }
    module.hot.accept("./ImageGallery.vue?vue&type=template&id=be64214e&scoped=true&", function () {
      api.rerender('be64214e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/ImageGallery.vue"
export default component.exports